export const GET_ADMIN_CAMPAIGN_FULFILLMENT = "GET_ADMIN_CAMPAIGN_FULFILLMENT"
export const GET_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS = "GET_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS"
export const GET_ADMIN_CAMPAIGN_FULFILLMENT_ERROR = "GET_ADMIN_CAMPAIGN_FULFILLMENT_ERROR"

export const EXPORT_ADMIN_CAMPAIGN_FULFILLMENT = "EXPORT_ADMIN_CAMPAIGN_FULFILLMENT"
export const EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS = "EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_SUCCESS"
export const EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_ERROR = "EXPORT_ADMIN_CAMPAIGN_FULFILLMENT_ERROR"